import '.c0{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.ds{right:-4px;}.ssr-plugin'
import '.dt{width:1.5rem;}.ssr-plugin'
import '.du{height:1.5rem;}.ssr-plugin'
import '.ai{border-radius:1.25rem;}.ssr-plugin'
import '.dv{background-color:var(--primary-red);}.ssr-plugin'
import '.b6{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  onDelete,
  onCancelDelete,
}: {
  src: string
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="c0 a b f"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--shades-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="a b f l bv ds dt du ai dv b6"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--shades-white)" />
    </div>
  )
}
